import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export interface BulkEditEapSettingsComponentProps {
    eapSettingId: string;
}

export const BulkEditEapSettingsComponent: React.FC<BulkEditEapSettingsComponentProps> = (props) => {
    const { eapSettingId } = props;

    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleOnEdit = () => {
        navigate(eapSettingId);
    };

    return (
        <PocButton className="bulk-action" variant="tertiary" size="medium" onClick={handleOnEdit}>
            <PocIcon slot="prefix" name="write" family="outlined" />
            {t('settings.devices.eap-settings.eap-config-list.action.edit')}
        </PocButton>
    );
};
